import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: ReactNode;
  rightSlot?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { className, leftIcon, rightSlot, ...rest },
  ref,
) {
  return (
    <div
      className={cn(
        "group flex h-9 items-center gap-2 rounded-md border border-border bg-surface px-3 transition-colors",
        "focus-within:border-ring/60 focus-within:ring-2 focus-within:ring-ring/20",
        className,
      )}
    >
      {leftIcon ? <span className="text-muted-fg [&>svg]:h-4 [&>svg]:w-4">{leftIcon}</span> : null}
      <input
        ref={ref}
        className="flex-1 bg-transparent text-sm placeholder:text-muted-fg focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
        {...rest}
      />
      {rightSlot ? <span className="text-muted-fg">{rightSlot}</span> : null}
    </div>
  );
});
